import type { GetTweetById200EngagementAllOf } from './getTweetById200EngagementAllOf';
import type { GetTweetById200EngagementAllOfTwo } from './getTweetById200EngagementAllOfTwo';

export type GetTweetById200Engagement = GetTweetById200EngagementAllOf & GetTweetById200EngagementAllOfTwo;
